import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class LocalExtFileDbTableDefinition extends DbTableDefinition {
  tableName = 'local_extFiles';
  tableStructure = `(id INTEGER PRIMARY KEY AUTOINCREMENT,
       databag LONGTEXT,
       fid LONGTEXT,
       fileextension TEXT,
       synctype TEXT,
       fileidentifier longtext,
       filecontent longtext,
       extfiletype TEXT,
       filesize INT(11),
       ownerid BIGINT(20),
       objref TEXT,
       version INT(10),
       extfileid TEXT,
       extfiletypeshortname TEXT,
       downloadStatus TEXT,
       downloadKey BIGINT(20),
       enableplanmarker BOOLEAN,
       acid BIGINT(20),
       aclabel TEXT,
       acukey VARCHAR(255)
      );`;

  constructor() {
    super();
    // Add UpdateStatements to Map
    this.updateStatements.set(26, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);
    if (Capacitor.getPlatform() === 'web') {
    } else {
    }
  }
}
